import React from 'react'
import PropTypes from 'prop-types'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Alert, Box, Paper, Stack, Typography } from '@mui/material'

export const DriveDonorsTabShell = ({
  statTitle,
  statSubtitle,
  showEligibilityBanner = true,
  eligibilityText = 'Eligibility is based on the requirements of this drive (all procedures).',
  aboutTitle,
  aboutText,
  selectionToolbar,
  exportAction,
  errorMessage,
  children,
}) => (
  <Stack spacing={2}>
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={2}
      alignItems='stretch'
    >
      <Paper
        elevation={0}
        sx={{
          p: 2,
          flex: 1,
          bgcolor: 'grey.100',
          borderRadius: 1,
        }}
      >
        <Typography variant='subtitle1' fontWeight={700}>
          {statTitle}
        </Typography>
        {statSubtitle ? (
          <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
            {statSubtitle}
          </Typography>
        ) : null}
      </Paper>

      {showEligibilityBanner ? (
        <Alert
          severity='info'
          icon={<InfoOutlinedIcon fontSize='inherit' />}
          sx={{ flex: 1, alignItems: 'center' }}
        >
          {eligibilityText}
        </Alert>
      ) : null}
    </Stack>

    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: 2,
        alignItems: { xs: 'stretch', lg: 'center' },
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      {selectionToolbar}
      {exportAction}
    </Box>

    {errorMessage ? <Alert severity='error'>{errorMessage}</Alert> : null}

    {children}

    {aboutTitle ? (
      <Alert severity='info' icon={<InfoOutlinedIcon fontSize='inherit' />}>
        <Typography variant='subtitle2' fontWeight={700}>
          {aboutTitle}
        </Typography>
        <Typography variant='body2' sx={{ mt: 0.5 }}>
          {aboutText}
        </Typography>
      </Alert>
    ) : null}
  </Stack>
)

DriveDonorsTabShell.propTypes = {
  statTitle: PropTypes.string,
  statSubtitle: PropTypes.string,
  showEligibilityBanner: PropTypes.bool,
  eligibilityText: PropTypes.string,
  aboutTitle: PropTypes.string,
  aboutText: PropTypes.string,
  selectionToolbar: PropTypes.node,
  exportAction: PropTypes.node,
  errorMessage: PropTypes.string,
  children: PropTypes.node,
}
